import { BATCH_PANEL_TITLE } from '../BatchAddDynamicFields/BatchAddDynamicFields.constants';

export const AddDynamicFieldLabel = {
  SINGLE: 'Add Dynamic Field',
  BATCH: BATCH_PANEL_TITLE,
  MENU_BUTTON_ARIA: 'More ways to add dynamic fields',
};
